import axios from "axios";
import { getLocalData } from "./storage";
import { Platform } from "react-native";
import { getMiddlewareApiUrl } from "../utils/urls";

const MIDDLEWARE_API = getMiddlewareApiUrl();

const middlewareAPI = axios.create({
  baseURL: MIDDLEWARE_API,
  headers: { "Content-Type": "application/json" },
});

middlewareAPI.interceptors.request.use(
  async (config) => {
    if (config.url != "/login") {
      let jwt = null;
      await getLocalData("@token").then((token) => {
        jwt = token;
      });
      if (jwt !== null && jwt !== undefined) {
        config.headers["Authorization"] = jwt;
      } else {
        return Promise.reject();
      }
    }
    return config;
  },
  function (error) {
    console.log("error", error);
    return Promise.reject(error);
  }
);

middlewareAPI.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

export default middlewareAPI;
